export const awardsData = [
  {
    title: 'Mathematics Award',
    organization: 'Coral Gables Senior High School',
    year: '2023-2024',
    icon: 'ri-trophy-line',
    description: 'Awarded to the top mathematics student at Coral Gables Senior High School, this honor recognizes exceptional analytical skill, academic excellence, and mastery of advanced mathematical concepts among the entire student body.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/11804e03cf1a871a54c64b51c847c680.jpeg'
  },
  {
    title: 'Rising Star Award',
    organization: 'Coral Gables Senior High School',
    year: '2024-2025',
    icon: 'ri-lightbulb-line',
    description: 'Awarded the Rising Star distinction at Coral Gables Senior High School, this honor recognizes exceptional leadership, growth, and impact, highlighting a student whose initiative and dedication set them apart across the school community.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/7ff34e19c1a8adc850b7c6d6270d9ad9.jpeg'
  },
  {
    title: 'Science Student of the Year Award',
    organization: 'Coral Gables Senior High School',
    year: '2022-2023',
    icon: 'ri-medal-line',
    description: 'Named Science Student of the Year at Coral Gables Senior High School, this award reflects consistent curiosity, dedication to learning, and meaningful academic growth, recognizing a student committed to understanding science with humility and purpose.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/fd90af7d3592f58cd33d4165f5d26340.jpeg'
  },
  {
    title: 'National Society of High School Scholars',
    organization: 'National Society of High School Scholars',
    year: '2024',
    icon: 'ri-medal-2-line',
    description: 'Inducted into the National Society of High School Scholars, a prestigious academic honor society recognizing outstanding students who have demonstrated excellence in scholarship, leadership, and commitment to academic achievement throughout their high school career.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/c4c0fbb60580945ba1d58b3cc6401312.png'
  },
  {
    title: 'Guitar-Superior Award',
    organization: 'National Federation of Music Clubs',
    year: '2022',
    icon: 'ri-star-line',
    description: 'Earned a Superior rating from the National Federation of Music Clubs for classical guitar performance, recognizing disciplined preparation, musical sensitivity, and a commitment to continual growth through thoughtful, expressive playing.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/77cb1de8080719bf066406a5f33c77db.jpeg'
  },
  {
    title: 'Phi Theta Kappa Member',
    organization: 'Phi Theta Kappa Honors Society',
    year: '2026',
    icon: 'ri-heart-line',
    description: 'Completed an intensive Dual Enrollment STEM pathway, earning nearly 80 college credits by high school graduation, reflecting sustained academic rigor, advanced coursework, and disciplined time management while balancing college, level science and mathematics with leadership and service.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/1dfde8f797b2e2d6aa93b178c93d5cf5.png'
  },
  {
    title: 'Best Presenter Award',
    organization: 'MDC Public Speaking',
    year: '2025',
    icon: 'ri-presentation-line',
    description: 'Awarded for delivering compelling presentations that inspired audiences and effectively communicated complex concepts with clarity and impact.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/4041273972e6f36765b4681d9ffce4cb.jpeg'
  },
  {
    title: 'ESB Small Business Certification',
    organization: 'Entrepreneurship and Small Business (ESB)',
    year: '2024',
    icon: 'ri-briefcase-line',
    description: 'Successfully earned the ESB Small Business Certification, demonstrating comprehensive knowledge of entrepreneurship fundamentals, business operations, financial management, and strategic planning essential for launching and managing a successful small business venture.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/31bb29f2af72530612a217042313af90.png'
  },
  {
    title: 'Harvard University Certificates',
    organization: 'Harvard University',
    year: '2024',
    icon: 'ri-graduation-cap-line',
    description: 'Successfully completed two rigorous Harvard University courses: Entrepreneurship, demonstrating comprehensive understanding of business innovation, venture development, strategic planning, and entrepreneurial leadership; and Human Anatomy and Physiology, gaining in-depth knowledge of biological systems, cellular mechanisms, and physiological processes through intensive study under renowned Harvard instructors.',
    image: 'https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/962b86cf6c9d2c33e8bb7e832524bd2e.png'
  }
];
